import React from "react";
import { Box } from "@material-ui/core";

import vehicleRouteCount2Icon from "../../assets/images/icons/vehicle-route-count-2.png";
import vehicleRouteCount3Icon from "../../assets/images/icons/vehicle-route-count-3.png";
import vehicleRouteCount4Icon from "../../assets/images/icons/vehicle-route-count-4.png";
import vehicleRouteCount5Icon from "../../assets/images/icons/vehicle-route-count-5.png";
import vehicleRouteCount6Icon from "../../assets/images/icons/vehicle-route-count-6.png";
import vehicleRouteCount7Icon from "../../assets/images/icons/vehicle-route-count-7.png";
import vehicleRouteCount8Icon from "../../assets/images/icons/vehicle-route-count-8.png";
import vehicleRouteCount9Icon from "../../assets/images/icons/vehicle-route-count-9.png";
import vehicleRouteCount9PlusIcon from "../../assets/images/icons/vehicle-route-count-9-plus.png";

const countIcons = {
  2: vehicleRouteCount2Icon,
  3: vehicleRouteCount3Icon,
  4: vehicleRouteCount4Icon,
  5: vehicleRouteCount5Icon,
  6: vehicleRouteCount6Icon,
  7: vehicleRouteCount7Icon,
  8: vehicleRouteCount8Icon,
  9: vehicleRouteCount9Icon
};

const CountIndicatorIcon = props => {
  const { count, style } = props;

  if (count < 2) {
    return null;
  }

  if (count > 9) {
    return (
      <Box>
        <img
          src={vehicleRouteCount9PlusIcon}
          width={17}
          height={17}
          style={style}
        />
      </Box>
    );
  }

  return (
    <Box>
      <img src={countIcons[count]} width={17} height={17} style={style} />
    </Box>
  );
};

export default CountIndicatorIcon;
